import {
  Badge,
  Breadcrumb,
  Col,
  Empty,
  Input, Pagination,
  Row,
  Space,
  Spin,
  Table
} from "antd";
import Button from "antd/es/button";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import {
  getTemplateAppInstallDetailList
} from "../../../axios/api.device";
import {
  DeviceTypes
} from "../../models";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const TemplateAppInstallDetail = () => {
  const routeParams: any = useParams();
  const routeLocation: any = useLocation();
  const [data, setData] = useState<any>();
  const [searchName, setSearchName] = useState<string>("");
  const [searchState, setSearchState] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [appInfo, setAppInfo] = useState<any>(routeLocation?.state);
  const [stateMapping, setStateMapping] = useState<any>({
    "success": "成功",
    "pending": "进行中",
    "fail": "失败",
  });
  const { t } = useTranslation();

  useEffect(() => {
    console.log(routeParams,routeLocation,appInfo);
    getList(pageIndex, pageSize);
  }, []);
  function onSearch() {
    getList(pageIndex, pageSize);
  }
  function getList(pgIndx: number, pgSize: number) {
      getTemplateAppInstallDetailList(appInfo?.templateId, appInfo?.packageName, {
        pageIndex: pgIndx,
        pageSize: pgSize,
        search: searchName
      }).then((res) => {
        setData(res.dataList);
        setTotalCount(res.totalCount)
        setPageSize(res.pageSize);
        setPageIndex(res.pageIndex);
      });
    }
  


  return (

    <div >
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
          <Breadcrumb.Item><Link to={"/home/profiles/appIndex"}>{t("应用")}</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to={"/home/profiles/appinstall/" + appInfo?.templateId}>{t("安装状态")}</Link></Breadcrumb.Item>
          <Breadcrumb.Item>{t("安装明细")}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>
          <Row className="borderBox">
            <Space size={30} >
              <Col>
                <img src={appInfo?.logoUrl} width="80" ></img>
              </Col>
              <Col >
                <Row>
                  <Col className="ft-20">{appInfo?.name}</Col>
                </Row>
                <Row>
                  <Space size={10}>
                    <Col> {appInfo?.platform.toLowerCase() === "ios" ? "iOS" : appInfo?.platform}</Col>
                    {/* <Col>{t("版本")}： {appInfo?.versionNumber}</Col> */}
                    <Col>{t("大小")}： {appInfo?.appSize}</Col>
                  </Space>
                </Row>
              </Col>
            </Space>
          </Row>
          <Row className="borderBox">
            <Col style={{marginBottom: 11}}>
              <Space size={24}>
                <Space>
                  <span>{t("设备信息")}</span>
                  <Input
                    placeholder={t("输入设备型号，终端用户搜索")}
                    value={searchName}
                    onChange={(e) =>
                      setSearchName(e.target.value)
                    }
                  ></Input>
                </Space>
                <Button type="primary" onClick={() => { onSearch(); }}>
                  {t("查询")}
                </Button>
              </Space>
            </Col>
          </Row>
          <Row className="borderBox">
            <Col span={24}>
              <Table
                size="middle"
                className="minHeight"
                loading={loading}
                dataSource={data}
                pagination={false}
                onChange={(pagination) => { }}
                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
              >
                {/* <Table.Column
                  title={t("绑定状态")}
                  key="status"
                  dataIndex="status"
                  render={(v) => (
                    <Badge color={v === 0 ? "red" : "green"} text={v === 0 ? "未绑定" : "已绑定"} />
                  )}
                ></Table.Column> */}
                <Table.Column
                  title={t("设备名称")}
                  key="deviceName"
                  dataIndex="deviceName"
                ></Table.Column>
                <Table.Column
                  title={t("序列号")}
                  key="serialNo"
                  dataIndex="serialNo"
                ></Table.Column>
                <Table.Column
                  title={t("设备类型")}
                  key="deviceType"
                  dataIndex="deviceType"
                  render={(v) => t(DeviceTypes[v])}
                ></Table.Column>
                <Table.Column title={t("设备型号")} key="model" dataIndex="model"></Table.Column>

                {/* <Table.Column
                  title={t("平台")}
                  key="platform"
                  dataIndex="platform"
                ></Table.Column> */}
                <Table.Column
                  title={t("系统版本")}
                  key="osVersion"
                  dataIndex="osVersion"
                ></Table.Column>
                <Table.Column title={t("用户")} key="userName" dataIndex="userName"></Table.Column>
                {/* <Table.Column
                  title={t("所属部门")}
                  key="organizationName"
                  dataIndex="organizationName"
                ></Table.Column> */}
                {/* <Table.Column
                  title={t("设备组")}
                  key="tags"
                  dataIndex="tags"
                  render={(v) => {
                    if (Array.isArray(v)) {
                      return v.map(
                        (item, i) =>
                          `${item?.value}${i < v.length - 1 ? "，" : ""}`
                      );
                    }
                    return null;
                  }}
                ></Table.Column> */}
                <Table.Column
                  title={t("应用版本")}
                  key="appVersion"
                  dataIndex="appVersion"
                ></Table.Column>
                <Table.Column
                    title={t("安装状态")}
                    key="appState"
                    dataIndex="appState"
                    render={(v) => {
                      return <Badge color={v === "fail" ? "red" : "green"} text={t(stateMapping[v])}/>
                    }}
                  ></Table.Column>
                                  <Table.Column
                  title={t("操作")}
                  key="id"
                  dataIndex="id"
                  align="center"
                  render={(v: string, r: any) => {
                      return (
                          <Space>
                              <Link target="_blank" className="ant-btn ant-btn-link" style={{padding: "0 5px"}} to={`/home/devices/details/${v}`}>{t("设备详情")}</Link>
                          </Space>
                      );
                  }}
              ></Table.Column>
              </Table>
              <Pagination
                style={{ textAlign: "right", marginTop: "20px" }}
                pageSize={pageSize}
                current={pageIndex}
                total={totalCount}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} / ${total} ${t("条")}`
                }
                onChange={(page, pageSize) => {
                  getList(page, pageSize ? pageSize : 0);
                }}
                onShowSizeChange={(current, size) => getList(current, size)}
              ></Pagination>
            </Col>
          </Row>

        </Row>
      </Spin>
    </div>

  );
};
